import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { showUpdate, remove, setPaginaAtual } from './cameraActions';
import SPButton from '../common/form/spButton';
import PermissaoUsuario from '../auth/permissao';
import ReactTableGT2A from '../common/grid/gridReactTable';
import ActionConfirmModal from '../common/components/actionConfirmModal';

const TIPO_LABEL = {
  deteccao: 'Detecção',
  monitoramento: 'Monitoramento',
};

class CameraList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      excluirCamera: null,
    };
    this.removerCamera = this.removerCamera.bind(this);
    this.confirmarExclusaoCamera = this.confirmarExclusaoCamera.bind(this);
    this.cancelarExclusaoCamera = this.cancelarExclusaoCamera.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange(page) {
    this.props.setPaginaAtual(page);
  }

  removerCamera(data) {
    this.setState({ excluirCamera: data });
  }

  confirmarExclusaoCamera() {
    const { excluirCamera } = this.state;
    if (!excluirCamera) return;
    this.props.remove(excluirCamera);
    this.setState({ excluirCamera: null });
  }

  cancelarExclusaoCamera() {
    this.setState({ excluirCamera: null });
  }

  render() {
    const cameras = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div>
            <PermissaoUsuario tela="CadCamera" condicao={true}>
              <SPButton
                type="button"
                className="warning btn-sm"
                icon="pencil-alt"
                data-title="Alterar"
                onClick={() => this.props.showUpdate(row.original)}
              />
              <SPButton
                type="button"
                className="danger btn-sm"
                icon="trash-alt"
                data-title="Excluir"
                onClick={() => this.removerCamera(row.original)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadCamera" condicao={false}>
              <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
              <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
            </PermissaoUsuario>
          </div>
        ),
        className: 'column_icon',
        width: 90,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Código',
        accessor: 'id',
        width: 70,
        filterable: true,
        className: 'column_grid column_center',
        resizable: true,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        minWidth: 160,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Tipo',
        accessor: 'tipo',
        width: 130,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => TIPO_LABEL[value] || value,
      },
      {
        Header: 'Controlador',
        id: 'controlador',
        accessor: row => `${row.numero_controlador || ''} - ${row.controlador_endereco || ''}`,
        minWidth: 180,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Endereço',
        accessor: 'endereco',
        minWidth: 200,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Ordem',
        accessor: 'ordem',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Ativo',
        accessor: 'ativo',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => (Number(value) === 1 ? 'Sim' : 'Não'),
      },
    ];

    return (
      <>
        <ReactTableGT2A
          data={cameras}
          columns={columns}
          className="-striped -highlight"
          defaultPageSize={15}
          onPageChange={this.handlePageChange}
          page={paginaAtual}
        />

        <ActionConfirmModal
          show={!!this.state.excluirCamera}
          title="Deseja realmente excluir?"
          message="A câmera será removida permanentemente do cadastro."
          itemName={this.state.excluirCamera ? this.state.excluirCamera.descricao : ''}
          itemDetail={
            this.state.excluirCamera
              ? `${TIPO_LABEL[this.state.excluirCamera.tipo] || this.state.excluirCamera.tipo} · Controlador ${this.state.excluirCamera.numero_controlador || '—'}`
              : ''
          }
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoCamera}
          onCancel={this.cancelarExclusaoCamera}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  list: state.cameraCad.list,
  paginaAtual: state.cameraCad.paginaAtual,
});

const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, setPaginaAtual }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CameraList);
